module.exports = __webpack_public_path__ + "img/banner_car_01.b3abdd45.jpg";